export const SEARCH_USER_DEPT_FILTER_LIST = {
  ASSIGN_PMC: ["BDC", "PMC"],
};
